<template>
  <div class="transfer-list-container">
    <div class="page-header">
      <div class="breadcrumb">ນັກຮຽນ / <span>ການຍົກຍ້າຍໂຮງຮຽນ</span></div>
      <div class="header-content">
        <h1>ຄຳຮ້ອງຍົກຍ້າຍໂຮງຮຽນນັກຮຽນ</h1>
        <button class="btn-primary" @click="$router.push('/home/students/transfer/new')">
          <i class="fas fa-plus"></i> ສ້າງຄຳຮ້ອງໃໝ່
        </button>
      </div>
    </div>

    <div class="panel">
      <div class="panel-head">
        <div class="tabs">
          <button class="tab-btn" :class="{ active: myQueue }" @click="setQueue(true)">
            <i class="fas fa-inbox"></i> ວຽກລໍຖ້າຂ້ອຍ
          </button>
          <button class="tab-btn" :class="{ active: !myQueue }" @click="setQueue(false)">
            <i class="fas fa-history"></i> ປະຫວັດທັງໝົດ
          </button>
        </div>
        <div class="filters">
          <select v-model="statusFilter" @change="handleSearch">
            <option value="">-- ທຸກສະຖານະ --</option>
            <option v-for="(label, key) in statusOptions" :key="key" :value="key">{{ label }}</option>
          </select>
          <div class="input-container">
            <i class="fas fa-search search-icon"></i>
            <input type="text" v-model="searchQuery" @keyup.enter="handleSearch" placeholder="ຄົ້ນຫາຊື່ ຫຼື ລະຫັດນັກຮຽນ...">
          </div>
          <button class="btn-search" @click="handleSearch">ຄົ້ນຫາ</button>
        </div>
      </div>

      <div class="panel-body">
        <div class="table-wrap">
          <table>
            <thead>
              <tr>
                <th>ລຳດັບ</th>
                <th>ນັກຮຽນ</th>
                <th>ໂຮງຮຽນຕົ້ນທາງ</th>
                <th>ໂຮງຮຽນປາຍທາງ</th>
                <th>ສະຖານະ</th>
                <th>ອັບເດດລ່າສຸດ</th>
                <th class="text-center">ຈັດການ</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(t, index) in items" :key="t._id">
                <td>{{ (currentPage - 1) * pageSize + index + 1 }}</td>
                <td class="text-left">{{ t.student_snapshot.firstNameLao }} {{ t.student_snapshot.familyNameLao }}</td>
                <td class="text-left">{{ t.from_school_name || t.from_school_id }}</td>
                <td class="text-left">{{ t.to_school_name || t.to_school_id }}</td>
                <td><span class="badge" :class="badgeClass(t.status)">{{ statusLabel(t.status) }}</span></td>
                <td>{{ formatDate(t.updated_at) }}</td>
                <td class="text-center">
                  <button class="panel-action" @click="$router.push(`/home/students/transfer/detail/${t._id}`)" title="ເບິ່ງ/ດຳເນີນການ">👁️</button>
                </td>
              </tr>
              <tr v-if="!loading && items.length === 0">
                <td colspan="7" class="text-center py-4">ບໍ່ມີຄຳຮ້ອງ</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pagination-container">
        <div class="pagination-info">ສະແດງ {{ startItem }} - {{ endItem }} ຈາກທັງໝົດ {{ totalRows }} ລາຍການ</div>
        <div class="pagination-controls">
          <button class="page-btn" :disabled="currentPage === 1" @click="changePage(currentPage - 1)">«</button>
          <template v-for="(page, idx) in visiblePages">
            <span v-if="page === '...'" :key="'e' + idx" class="page-ellipsis">…</span>
            <button v-else :key="page" class="page-btn" :class="{ active: currentPage === page }" @click="changePage(page)">{{ page }}</button>
          </template>
          <button class="page-btn" :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">»</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/utils/api';
import { TRANSFER_STATUS_LABELS, transferStatusLabel, transferStatusBadgeClass } from '@/utils/studentTransferStatus';
import { getPaginationRange } from '@/utils/pagination';

export default {
  name: 'StudentTransferListPage',
  data() {
    return {
      items: [],
      currentPage: 1,
      pageSize: 20,
      totalRows: 0,
      loading: false,
      searchQuery: '',
      statusFilter: '',
      myQueue: true,
      user: {},
      statusOptions: TRANSFER_STATUS_LABELS,
      searchTimer: null
    };
  },
  computed: {
    totalPages() { return Math.ceil(this.totalRows / this.pageSize) || 1; },
    visiblePages() { return getPaginationRange(this.currentPage, this.totalPages); },
    startItem() { return this.totalRows === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1; },
    endItem() {
      const end = this.currentPage * this.pageSize;
      return end > this.totalRows ? this.totalRows : end;
    }
  },
  watch: {
    searchQuery() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.handleSearch(), 500);
    }
  },
  mounted() {
    this.loadUserInfo();
    this.fetchItems();
  },
  methods: {
    loadUserInfo() {
      const savedInfo = localStorage.getItem('user-info');
      if (savedInfo) {
        try { this.user = JSON.parse(savedInfo); } catch (e) { this.user = {}; }
      }
    },
    setQueue(val) {
      this.myQueue = val;
      this.currentPage = 1;
      this.fetchItems();
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchItems();
    },
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.fetchItems();
      }
    },
    async fetchItems() {
      this.loading = true;
      try {
        const res = await api.get('/student-transfers', {
          params: {
            page: this.currentPage,
            limit: this.pageSize,
            search: this.searchQuery,
            status: this.statusFilter,
            my_queue: this.myQueue ? 1 : 0,
            org_role: this.user.org_role || 'school',
            prov_id: this.user.prov_id,
            district_id: this.user.district_id,
            school_id: this.user.school_id,
            created_by: this.user.username,
            user_level: this.user.user_level
          }
        });
        if (res.data.code === 1) {
          this.items = res.data.rows;
          this.totalRows = res.data.totalRows || res.data.rows.length;
        }
      } catch (e) {
        console.error('fetchItems error:', e);
      } finally {
        this.loading = false;
      }
    },
    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('lo-LA', { year: 'numeric', month: '2-digit', day: '2-digit' });
    },
    statusLabel(v) { return transferStatusLabel(v); },
    badgeClass(v) { return transferStatusBadgeClass(v); }
  }
};
</script>

<style scoped>
.transfer-list-container { animation: fadeIn 0.4s ease; }
.header-content { display: flex; justify-content: space-between; align-items: center; margin-top: 10px; }
.panel-head { display: flex; flex-direction: column; gap: 12px; padding: 15px 20px; }
.tabs { display: flex; gap: 8px; }
.tab-btn {
  border: 1px solid var(--border); background: #fff; color: var(--text2); padding: 8px 16px;
  border-radius: 8px; cursor: pointer; font-size: 13px; font-weight: 500; display: flex; align-items: center; gap: 8px;
}
.tab-btn.active { background: var(--lao); color: #fff; border-color: var(--lao); }
.filters { display: flex; gap: 10px; align-items: center; flex-wrap: wrap; }
.filters select { padding: 9px 10px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; }
.input-container { position: relative; flex: 1; max-width: 320px; }
.search-icon { position: absolute; left: 12px; top: 50%; transform: translateY(-50%); color: var(--text3); }
.input-container input { width: 100%; padding: 9px 10px 9px 35px; border: 1px solid var(--border); border-radius: 8px; font-size: 13px; }
.btn-search { background: var(--lao); color: white; border: none; padding: 0 18px; border-radius: 8px; cursor: pointer; font-weight: 500; }
.btn-primary {
  background: var(--lao); color: white; border: none; padding: 8px 16px; border-radius: 6px;
  cursor: pointer; font-weight: 500; display: flex; align-items: center; gap: 8px;
}
.btn-primary:hover { background: var(--lao-mid); }

.badge { font-size: 11px; padding: 4px 9px; border-radius: 6px; font-weight: 700; }
.badge-success { background: var(--success-bg); color: var(--success); }
.badge-warning { background: var(--warning-bg); color: var(--warning); }
.badge-danger { background: var(--danger-bg); color: var(--danger); }
.badge-neutral { background: var(--surface); color: var(--text2); }

.pagination-container { display: flex; justify-content: space-between; align-items: center; padding: 15px 20px; border-top: 1px solid var(--border); }
.page-btn { padding: 5px 12px; border: 1px solid var(--border); background: white; border-radius: 4px; cursor: pointer; margin: 0 2px; }
.page-btn.active { background: var(--lao); color: white; border-color: var(--lao); }
.page-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.page-ellipsis { padding: 5px 6px; color: var(--text3); }
.text-center { text-align: center; }
.text-left { text-align: left; }
.py-4 { padding-top: 1.5rem; padding-bottom: 1.5rem; }

@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
